import React from 'react';
export function Footer() {
  return <footer className="bg-carbon px-4 py-4" data-id="element-64" data-mp="32wd2qgad7ltj">
      <div className="mx-auto max-w-3xl text-center" data-id="element-65" data-mp="3gezeh7brdx2q">
        <p className="text-[11px] font-semibold text-white/80" data-id="element-66" data-mp="3ggk6ap6ov1ww">
          © 2026 INDUSTRIAL MAINTENANCE DIAGNOSTIC PRO™ — All Rights Reserved.
        </p>
        <p className="mx-auto mt-1 max-w-2xl text-[11px] font-medium leading-snug text-white/55" data-id="element-67" data-mp="36oxwmxa01aw9">
          INDUSTRIAL MAINTENANCE DIAGNOSTIC PRO™ is a professional
          troubleshooting reference resource. It does not replace required
          training, manufacturer instructions, workplace safety procedures or
          qualified professional judgment.
        </p>
        <nav aria-label="Legal" className="mt-1 flex flex-wrap items-center justify-center gap-x-2 gap-y-0.5 text-[11px] font-semibold text-white/70" data-id="element-68" data-mp="3qdf5796vj4bp">
          <a href="#offer" className="transition-colors duration-150 hover:text-volt" data-id="element-69" data-mp="2a19v9qy5pwze">
            Terms &amp; Conditions
          </a>
          <span aria-hidden="true" data-id="element-70" data-mp="3labqfslx60os">•</span>
          <a href="#offer" className="transition-colors duration-150 hover:text-volt" data-id="element-71" data-mp="3gagyrmubl72o">
            Privacy Policy
          </a>
          <span aria-hidden="true" data-id="element-72" data-mp="3v9azhcaljycb">•</span>
          <a href="mailto:kitonline27@gmail.com" className="transition-colors duration-150 hover:text-volt" data-id="element-73" data-mp="3q8n2m9zosna6">
            Contact
          </a>
        </nav>
        <p className="mt-1 text-[11px] font-medium text-white/55" data-id="element-74" data-mp="33xd9vvh5urg">
          Support:{' '}
          <a href="mailto:kitonline27@gmail.com" className="font-semibold text-volt" data-id="element-75" data-mp="323239a09h0k">
            kitonline27@gmail.com
          </a>
        </p>
      </div>
    </footer>;
}